import React, { useEffect, useState } from 'react';
import { useFieldHelper, FieldProps, TextField, TextFieldValue } from 'framework/ui/field';
import useOfficeService, { OFFICE_NAMES } from '../officeService';
import { InputLoader } from 'framework/ui/mui-builder';

const EmployeeOfficeField = (props: FieldProps<TextFieldValue>) => {
  const { additionalValues } = props;
  const [displayedValue, setDisplayedValue] = useState(null);
  const { getValue } = useFieldHelper(props);
  const { findAll } = useOfficeService();
  const contextValue = getValue();

  useEffect(() => {
    (async () => {
      let offices = await findAll();
      if (additionalValues) {
        offices = offices.concat(additionalValues);
      }
      const office = offices.find((item: { id: TextFieldValue }) => Number(item.id) === Number(contextValue)) || {};
      const officesNames = { ...OFFICE_NAMES };
      if (additionalValues) {
        additionalValues.forEach((value: { name: string | number; label: any }) => {
          officesNames[value.name] = value.label || value.name;
        });
      }
      setDisplayedValue(officesNames[office.name]);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue]);

  if (displayedValue === null) {
    return <InputLoader />;
  }

  return <TextField {...props} value={displayedValue} />;
};

export default EmployeeOfficeField;
